import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ProductLocationAssortmentStatus } from "src/app/enum";
import { formatDiff } from "src/app/util/fn";

@Component({
  template: ""
})
export class ProductLocationsBase {
  @Input() public locations: Owner[];
  @Input() public showValidationWall = false;

  public locationCount: number | null = null;
  public locationDiff: number;

  constructor(private _translateService: TranslateService) { }

  protected _calculateLocationData(): void {
    if (!this.locations) {
      return;
    }

    this.locationCount = this.locations.reduce(
      (acc: number, owner: Owner) =>
        acc +
        this.getActiveLocationCount(owner.locations),
      0
    );

    this.locationDiff = this.locations
      .reduce((all: OwnerLocation[], owner: Owner) => {
        all.push(...owner.locations);
        return all;
      }, [])
      .reduce(
        (acc: number, location: OwnerLocation) => this.calcDiff(acc, location),
        0
      );
  }

  public getActiveLocationCount(locations: OwnerLocation[]) {
    return locations.filter(
      (x) => x.status !== ProductLocationAssortmentStatus.Removed
    ).length
  }

  public getDiffClass(diff: number): string {
    if (diff > 0) {
      return "added";
    } else if (diff < 0) {
      return "removed";
    } else {
      return "no-change";
    }
  }

  public getFormattedDiffSummaryPart(diff: number) {
    const diffClass = this.getDiffClass(diff);
    const formattedDiff = this.formatDiff(diff);
    const tooltip = this._translateService.instant(
      "components.product_locations_info." + diffClass,
      { count: diff }
    );
    return { diffClass, formattedDiff, tooltip };
  }

  public formatDiff(diff: number): string {
    return formatDiff(diff);
  }

  public calcDiff(acc: number, location: OwnerLocation): number {
    if (location.status === ProductLocationAssortmentStatus.Added) {
      return acc + 1;
    } else if (location.status === ProductLocationAssortmentStatus.Removed) {
      return acc - 1;
    }
    return acc;
  }
}

export interface OwnerLocation {
  status: ProductLocationAssortmentStatus;
  name: string;
}

export interface Owner {
  ownerId: string;
  ownerName: string;
  locations: OwnerLocation[];
}
